import { NgModule } from "@angular/core";
import { DropdownRatingFilterComponent2 } from "./dropdown-rating-filter2/dropdown-rating-filter2.component";
import { DropdownRangeSliderComponent2 } from "./dropdown-range-slider2/dropdown-range-slider2.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import {DropdownRatingFilterComponent3} from './dropdown-rating-filter3/dropdown-rating-filter3.component';
import { DropdownRangeSliderComponent3 } from "./dropdown-range-slider3/dropdown-range-slider3.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PipesModule
    ],
    declarations: [
        DropdownRatingFilterComponent2,
        DropdownRatingFilterComponent3,
        DropdownRangeSliderComponent2,
        DropdownRangeSliderComponent3
    ],
    exports: [
        DropdownRatingFilterComponent2,
        DropdownRatingFilterComponent3,
        DropdownRangeSliderComponent2,
        DropdownRangeSliderComponent3
    ]
})
export class DropdownsModule { }
